import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { Command, CommandGroup, CommandItem, CommandInput } from "@/components/ui/command"
import { Check } from "lucide-react"
import { cn } from "@/lib/utils"

export function MultiSelect({
                                options,
                                value,
                                onChange,
                                placeholder = "Select options",
                                searchable = true,
                            }) {
    const [open, setOpen] = useState(false)

    const toggleValue = (val) => {
        if (value.includes(val)) {
            onChange(value.filter((v) => v !== val))
        } else {
            onChange([...value, val])
        }
    }

    const selectedLabels = value
        .map((val) => options.find((o) => o.value === val)?.label || val)
        .join(", ")

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button variant="outline" className="w-full justify-between">
                    {selectedLabels || placeholder}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[250px] p-0">
                <Command>
                    {searchable && <CommandInput placeholder="Search..." />}
                    <CommandGroup>
                        {options.map((opt) => (
                            <CommandItem
                                key={opt.value}
                                onSelect={() => toggleValue(opt.value)}
                            >
                                <Check
                                    className={cn(
                                        "mr-2 h-4 w-4",
                                        value.includes(opt.value) ? "opacity-100" : "opacity-0"
                                    )}
                                />
                                {opt.label}
                            </CommandItem>
                        ))}
                    </CommandGroup>
                </Command>
            </PopoverContent>
        </Popover>
    )
}
